import React, { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

import customer from '../../assets/navbar/customer.svg';
import logout from '../../assets/navbar/logout.png';
import dashboard from '../../assets/navbar/dashboard.svg';
import program from '../../assets/navbar/program.svg';
import vip from '../../assets/navbar/vip.svg';
import getActiveRewardCount from '../../utils/getActiveRewardCount';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { logoutUser } from '../../store/userSlice';

type NavbarCardsProps = {
  icon: string;
  title: string;
  notification?: number | string;
  navigateTo?: string;
  type?: string;
};

const NavbarCards = ({
  icon,
  title,
  notification,
  navigateTo,
  type,
}: NavbarCardsProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div
      className='w-full cursor-pointer p-4 flex flex-col items-center justify-center gap-1 relative '
      onClick={() => {
        if (type === 'logOut') {
          dispatch(logoutUser());
        } else {
          navigate(navigateTo || '/');
        }
      }}
    >
      <img src={icon} alt='logo-link' className='w-[24px] h-[24px]' />
      <p className='text-[12px] font-medium text-[#808080]'>{title}</p>

      {notification ? (
        <div className='absolute w-[20px] h-[20px] rounded-full border text-[10px] bg-[#32E89A] flex items-center justify-center font-semibold top-2 right-4'>
          {notification}
        </div>
      ) : null}
    </div>
  );
};

const Navbar = () => {
  const [activeRewardCount, setActiveRewardCount] = useState('0');
  const token = useSelector((state: RootState) => state.user.token);
  const navigator = useNavigate();

  const navOptions: NavbarCardsProps[] = [
    {
      icon: dashboard,
      title: 'Dashboard',
      navigateTo: '/dashboard',
    },
    {
      icon: vip,
      title: 'Tiers',
      navigateTo: '/tier',
    },
    {
      icon: program,
      title: 'Program',
      notification: activeRewardCount,
      navigateTo: '/program',
    },
    {
      icon: customer,
      title: 'Customer',
      navigateTo: '/customer',
    },
    {
      icon: logout,
      title: 'Logout',
      type: 'logOut',
    },
  ];

  const getRewardCountData = async () => {
    const count = await getActiveRewardCount();
    setActiveRewardCount(count);
  };

  const checkForToken = () => {
    if (!token) {
      navigator('/login');
    }
  };

  useEffect(() => {
    checkForToken();
    getRewardCountData();
  }, [token]);

  return (
    <div className='flex border min-h-screen'>
      <div className='hidden md:flex flex-col w-[120px]  bg-white p-2 border gap-4'>
        {navOptions.map((option, index) => (
          <NavbarCards key={index} {...option} />
        ))}
      </div>{' '}
      <div className='w-full'>
        <Outlet />
      </div>
    </div>
  );
};

export default Navbar;
